/** True in the browser, false during prerender (Node) and SSR. */
export const isBrowser = typeof window !== 'undefined'
